import { schemas } from 'constants/schemas';
import type { SMSNotification } from 'models/smsNotification';
import type { SMSNotificationResponse } from 'services/payex/payments/types';
import { normalizeResponse } from 'utils/normalize/normalize';

export const normalizeSmsNotifications = (
  smsNotification: SMSNotificationResponse,
): {
  entities: {
    smsNotification: Record<string, SMSNotification>;
  };
  result: string[];
} => normalizeResponse(smsNotification, schemas.smsNotification);
